export default __webpack_public_path__ + "static/truband-b357b8ac7945bafc14f90aaf5c6225d3.png";